const ArrayBufferConcat = function (buffer1, buffer2) {
    if (!(buffer1 instanceof ArrayBuffer))
        throw new TypeError('Buffer1 must be an instance of ArrayBuffer');
    if (!(buffer2 instanceof ArrayBuffer))
        throw new TypeError('Buffer2 must be an instance of ArrayBuffer');
    const length = buffer1.byteLength + buffer2.byteLength;
    const destView = new Uint8Array(new ArrayBuffer(length));
    const view1 = new Uint8Array(buffer1);
    const view2 = new Uint8Array(buffer2);
    destView.set(view1);
    destView.set(view2, view1.length);
    return destView.buffer;
};
const ArrayBufferShed = function (buffer, bytes) {
    if (!(buffer instanceof ArrayBuffer))
        throw new TypeError('Buffer must be an instance of ArrayBuffer');
    const length = buffer.byteLength - bytes;
    if (length < 0)
        throw new Error('Cannot shed ' + bytes + ' if we only have ' + buffer.byteLength);
    const destView = new Uint8Array(new ArrayBuffer(length));
    const sourceView = new Uint8Array(buffer, bytes);
    destView.set(sourceView);
    return destView.buffer;
};

export default class Player {
    play(text, voiceId) {
        return fetch("/tts", {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                text: text,
                voiceId: voiceId
            })
        }).then(response => response.json()).then(data => {
            if (data.results && data.results.filename) {
                return fetch(data.results.filename).then(response => {

                    if (!response.ok) {
                        console.log('Request responded with error: ' + response.status);
                        return;
                    }

                    if (response.headers.get('content-type') === 'text/plain') {
                        response.text().then(text => {
                            console.log('Request responded with text: ' + text);
                        });
                        return;
                    }

                    const reader = response.body.getReader();
                    const player = new PCMPlayer({
                        encoding: '16bitInt',
                        channels: 1,
                        sampleRate: 22050,
                        flushingTime: 50
                    });
                    this.stop();
                    this.player = player;
                    player.played = 0;
                    player.total = 0;

                    const state = {};
                    state.buffer = new ArrayBuffer(0);
                    function read() {
                        return reader.read().then(({value, done}) => {
                            /* convert to 16 bits */
                            if (value && value.buffer) {
                                state.buffer = ArrayBufferConcat(state.buffer, value.buffer);
                                const newSamples = Math.floor(state.buffer.byteLength / 2);
                                player.total += newSamples;

                                const view = new DataView(state.buffer, 0, newSamples * 2);

                                var data = new Uint16Array(newSamples);
                                for (let i = 0; i < newSamples * 2; i += 2) {
                                    data[i / 2] = view.getUint8(i) + view.getUint8(i + 1) * 256;
                                }

                                if (player) {
                                    player.feed(data);
                                }
                                state.buffer = ArrayBufferShed(state.buffer, newSamples * 2);
                            }
                            if (done || !player) {
                                return;
                            }
                            read();
                        });
                    }

                    return read();
                }).then(() => {
                    return new Promise((resolve, reject) => {
                        this.reject = reject;
                        this.player.callback = resolve;
                    })
                });
            } else {
                console.error(data);
                return Promise.resolve();
            }
        })
    }

    stop(abort = false) {
        if (this.player) {
            if (abort) {
                this.player.callback = this.reject;
            }
            this.player.destroy();
            this.player = null;
        }
    }
}

export const PCMPlayer = function (option) {
    this.init(option);
};

PCMPlayer.prototype.init = function (option) {
    var defaults = {
        encoding: '16bitInt',
        channels: 1,
        sampleRate: 8000,
        flushingTime: 1000
    };
    this.option = Object.assign({}, defaults, option);
    this.samples = new Float32Array();
    this.flush = this.flush.bind(this);
    this.interval = setInterval(this.flush, this.option.flushingTime);
    this.maxValue = this.getMaxValue();
    this.typedArray = this.getTypedArray();
    this.createContext();
};

PCMPlayer.prototype.getMaxValue = function () {
    var encodings = {
        '8bitInt': 128,
        '16bitInt': 32768,
        '32bitInt': 2147483648,
        '32bitFloat': 1
    };

    return encodings[this.option.encoding] ? encodings[this.option.encoding] : encodings['16bitInt'];
};

PCMPlayer.prototype.getTypedArray = function () {
    var typedArrays = {
        '8bitInt': Int8Array,
        '16bitInt': Int16Array,
        '32bitInt': Int32Array,
        '32bitFloat': Float32Array
    };

    return typedArrays[this.option.encoding] ? typedArrays[this.option.encoding] : typedArrays['16bitInt'];
};

PCMPlayer.prototype.createContext = function () {
    this.audioCtx = new (window.AudioContext || window.webkitAudioContext)();
    this.gainNode = this.audioCtx.createGain();
    this.gainNode.gain.value = 1;
    this.gainNode.connect(this.audioCtx.destination);
    this.startTime = this.audioCtx.currentTime;
};

PCMPlayer.prototype.isTypedArray = function (data) {
    return (data.byteLength && data.buffer && data.buffer.constructor === ArrayBuffer);
};

PCMPlayer.prototype.feed = function (data) {
    if (!this.samples) return;
    if (!this.isTypedArray(data)) {
        console.log('not typed array');
        return;
    }
    data = this.getFormatedValue(data);
    var tmp = new Float32Array(this.samples.length + data.length);
    tmp.set(this.samples, 0);
    tmp.set(data, this.samples.length);
    this.samples = tmp;
};

PCMPlayer.prototype.getFormatedValue = function (data) {
    var data = new this.typedArray(data.buffer),
        float32 = new Float32Array(data.length),
        i;

    for (i = 0; i < data.length; i++) {
        float32[i] = data[i] / this.maxValue;
    }
    return float32;
};

PCMPlayer.prototype.volume = function (volume) {
    this.gainNode.gain.value = volume;
};

PCMPlayer.prototype.destroy = function () {
    if (this.interval) {
        clearInterval(this.interval);
    }
    this.samples = null;
    if (this.audioCtx) {
        this.audioCtx.close();
    }
    this.audioCtx = null;
    if (this.callback) {
        this.callback();
    }
};

PCMPlayer.prototype.flush = function () {
    if (!this.samples.length) return;
    var bufferSource = this.audioCtx.createBufferSource(),
        length = this.samples.length / this.option.channels,
        audioBuffer = this.audioCtx.createBuffer(this.option.channels, length, this.option.sampleRate),
        audioData,
        channel,
        offset,
        i,
        decrement;

    for (channel = 0; channel < this.option.channels; channel++) {
        audioData = audioBuffer.getChannelData(channel);
        offset = channel;
        decrement = 50;
        for (i = 0; i < length; i++) {
            audioData[i] = this.samples[offset];
            /* fadein */
            if (i < 50) {
                audioData[i] = (audioData[i] * i) / 50;
            }
            /* fadeout*/
            if (i >= (length - 51)) {
                audioData[i] = (audioData[i] * decrement--) / 50;
            }
            offset += this.option.channels;
        }
    }

    if (this.startTime < this.audioCtx.currentTime) {
        this.startTime = this.audioCtx.currentTime;
    }
    bufferSource.buffer = audioBuffer;
    bufferSource.onended = () => {
        this.played += bufferSource.buffer.length;
        if (this.played === this.total) {
            this.destroy();
        }
    };
    bufferSource.connect(this.gainNode);
    bufferSource.start(this.startTime);
    this.startTime += audioBuffer.duration;
    this.samples = new Float32Array();
};